<div class="item-container flex w-full flex-1 flex-col justify-start gap-2">
  <div class="flex flex-col justify-between lg:flex-row" [ngClass]="{ 'gap-4': viewDetails }">
    <div class="flex flex-row gap-[15px]">
      <div class="flex flex-col items-center justify-center">
        <ion-thumbnail slot="start">
          <img
            class="product-image"
            [src]="item.product.printingGroup.files[0]?.thumbFile?.url || '/assets/images/logo/logo-negro.svg'"
          />
        </ion-thumbnail>
      </div>
      <div class="flex flex-col">
        <div class="info-part flex flex-col">
          <div>
            <div class="item-title" [tooltip]="getFolderName(item, i)">{{ getFolderName(item, i) }}</div>
            <span class="text-red-500" *ngIf="item.unavailable"
              >Lo sentimos, los documentos de este grupo ya no están disponibles
            </span>
          </div>

          <div class="4 flex flex-row items-center" *ngIf="item.product.unitPrice">
            <div class="item-price flex flex-col items-center justify-center">
              {{ item.product.printingGroup.files.length }} archivos (x{{ item.qty }})
            </div>
          </div>
        </div>

        <div *ngIf="item.qty > item.product.stock && !item.product.allowSaleNoStock">
          <span class="stock-error" *ngIf="item.product.stock >= 1"
            >Lo sentimos pero solo quedan {{ item.product.stock }} unidades en stock.</span
          >
          <span class="stock-error" *ngIf="item.product.stock < 1"
            >Lo sentimos pero en este momento este producto está agotado.</span
          >
        </div>

        <div *ngIf="item.product.stock === undefined">
          <span class="stock-error">Lo sentimos pero este producto ya no está disponible.</span>
        </div>
      </div>
    </div>

    <div class="flex w-full flex-col items-center justify-center lg:w-1/2 lg:items-end">
      <div class="right-part ml-auto flex w-full flex-row items-center justify-end gap-5 lg:m-0">
        <app-qty-stepper
          *ngIf="cartService.currentStep < 2 && !disableActions"
          class="flex-initial"
          [qty]="item.qty"
          [min]="1"
          [max]="9999"
          [showQty]="true"
          (changes)="onQtyChange($event)"
          [disabled]="cartService.currentStep >= 2"
        >
        </app-qty-stepper>

        <span *ngIf="cartService.currentStep >= 2 || showQty" class="showQty">x{{ item.qty }}</span>

        <div class="item-price flex-initial">{{ item.price.amt | currency: item.price.cur }}</div>
        <ion-button
          class="flex-initial"
          *ngIf="cartService.currentStep < 2 && !disableActions"
          fill="clear"
          color="danger"
          size="small"
          (click)="onDelete(item)"
        >
          <svg
            class="danger"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 120 141"
            style="enable-background: new 0 0 120 141"
            xml:space="preserve"
          >
            <style type="text/css">
              .st0 {
                clip-path: url(#SVGID_2_);
              }
            </style>
            <g>
              <defs>
                <rect id="SVGID_1_" x="0.8" width="119" height="141" />
              </defs>
              <clipPath id="SVGID_2_">
                <use xlink:href="#SVGID_1_" style="overflow: visible" />
              </clipPath>
              <g>
                <path
                  d="M11.5,32.3c-2.2-0.4-4-0.6-5.8-0.9c-3.2-0.7-4.8-2.2-4.8-4.4c0-2.3,1.6-4.2,4.9-4.6c4.7-0.6,9.4-0.8,14.2-1
            c2.6-0.1,5.1,0,8.1,0c-0.4-2-0.7-3.5-1.1-5c-0.8-3.1-0.4-6.3,1.1-9.1c2-3.8,5.1-6.2,9.4-6.3c8-0.3,15.9-0.4,23.9-0.4
            c5.3,0,10.6,0.2,15.8,0.3c0.8,0,1.5,0,2.3,0.1c5.4,0.4,8.8,3.2,10.1,8.4c0.6,2.4,0.6,4.9,0.9,7.3c0.1,1.3,0.2,2.5,0.3,4
            c0.9,0.1,1.7,0.2,2.6,0.2c5.8-0.2,11.6-0.4,17.4-0.5c1.5-0.1,3,0.1,4.5,0.4c1.2,0.3,2.2,0.9,3,1.8c0.8,0.9,1.2,2.1,1.3,3.3
            c0.2,1.2,0,2.5-0.5,3.6c-0.5,1.1-1.4,2.1-2.5,2.7c-0.9,0.5-1.9,1-3,1.5c0,3.1-0.1,6.2,0,9.3c0.7,18.4,1.8,36.8,1.1,55.2
            c-0.2,6.7-0.7,13.3-1.6,19.9c-0.5,3.7-2,7.2-3.3,10.7c-0.6,1.7-1.6,3.2-2.9,4.4c-1.3,1.2-2.9,2.2-4.6,2.7
            c-3.1,1.1-6.4,1.9-9.7,2.4c-3,0.4-6,0.6-9,0.6c-11.7,0.6-23.4,1.3-35.2,1.7c-4.9,0.2-9.9,0-14.8-0.6c-12.6-1.8-19.5-8.7-21.5-21.4
            c-0.6-3.5-0.9-7-1-10.6c-0.1-20.3-0.2-40.7-0.1-61C10.9,42.2,11.3,37.4,11.5,32.3z M21.2,33.1c0.6,10,1,59.2,2.2,74
            c0.3,4.4,1.3,8.7,2.2,13c0.9,4.3,3.8,6.8,7.9,7.5c4.7,0.8,9.4,1.5,14.1,1.4c11.7-0.1,23.5-0.5,35.2-1c4.5-0.2,9-1,13.4-1.7
            c0.8-0.1,1.6-0.5,2.2-1c0.6-0.6,1-1.3,1.2-2.1c0.6-2.5,1.4-5,1.7-7.5c1.7-14.6,1.3-29.2,0.9-43.8c-0.4-11.5-0.8-23-1.2-34.5
            c0-1-0.1-2.1-0.2-3C73.4,33.9,48.9,33.5,21.2,33.1L21.2,33.1z M38.5,21c13.5,0.5,26.8,0.5,40.1-0.2v-8.9
            c-13.5-0.5-26.7-0.9-40.1,0.4V21z"
                />
                <path
                  d="M82.2,77.8c-0.1-6.9-0.5-14-0.8-20.8l0-0.1c-0.1-2.5-0.2-4.9-0.3-7.4c0-0.9-0.2-1.7-0.5-2.5C80,45,78.7,44,76.9,44.2
            c-1,0.1-2.9,0.6-3.2,3.3c-0.1,0.5-0.1,1-0.1,1.4c-0.1,8.6-0.9,36.9-0.9,37.2c-0.1,6.8-0.3,13.8-0.4,20.8c-0.1,1.9,0.1,3.8,0.5,5.7
            c0.2,1,0.7,1.9,1.5,2.5c0.8,0.6,1.8,1,2.8,1c0.1,0,0.2,0,0.4,0c1,0,2-0.4,2.7-1.1c0.7-0.7,1.2-1.6,1.4-2.6
            c0.4-2.1,0.5-4.2,0.6-6.3l0-4.8C82.3,93.6,82.4,85.6,82.2,77.8z"
                />
                <path
                  d="M47.6,44.6L47.6,44.6c-0.6,0-1.3,0.2-1.9,0.4c-0.6,0.3-1.1,0.7-1.4,1.3c-0.6,1.1-1,2.4-1,3.6c-0.1,1.7-0.2,3.5-0.3,5.2
            c-0.4,6.1-0.8,12.4-1,18.6c-0.3,8.8-0.3,17.8-0.4,26.5c0,2.7-0.1,5.3-0.1,8c0,1.1,0.2,2.2,0.5,3.2c0.7,2.5,2.4,4.1,4.4,4.1h0.1
            c2.1,0,3.8-1.7,4.3-4.3c0.2-1.4,0.4-2.7,0.3-4.1c-0.1-7.1-0.3-14.1-0.4-20.8l-0.1-6.1l0.1-7.2c0.1-7.8,0.3-15.2,0.4-22.6
            c0.1-1.2-0.1-2.5-0.5-3.7c-0.3-0.6-0.7-1.1-1.2-1.5C48.8,45,48.2,44.7,47.6,44.6z"
                />
              </g>
            </g>
          </svg>
        </ion-button>
      </div>

      <ion-button
        class="view-details-button flex w-fit items-center justify-center gap-[3px]"
        fill="clear"
        size="small"
        (click)="toggleViewDetails()"
      >
        <span>{{ viewDetails ? 'ocultar detalles' : 'ver detalles' }}</span>
        <img [ngClass]="{ '-scale-y-100': viewDetails }" src="../../../assets/icon/flechaAbajo.svg" />
      </ion-button>
    </div>
  </div>

  <div
    *ngIf="cartService.exceededBindingItems(item.product.printingGroup).length && !disableActions"
    class="noStock font-medium"
  >
    <span>No hay stock suficiente para los siguientes elementos:</span>
    <ul>
      <li *ngFor="let element of cartService.exceededBindingItems(item.product.printingGroup)">
        {{ element }}
      </li>
    </ul>
  </div>

  <div
    class="flex flex-col gap-[15px]"
    [ngClass]="{ 'hidden-printing-details': !viewDetails, 'printing-details': viewDetails }"
  >
    <ion-button
      *ngIf="!item.notEditable && !item.unavailable && cartService.currentStep < 2 && !disableActions"
      appPreventDoubleClick
      class="edit-folder-button mt-2 flex w-fit flex-row gap-[5px] self-end"
      (throttledClick)="editPrintProduct(item)"
    >
      <ion-icon src="../../../assets/icon/lapizEditar.svg"></ion-icon>
      <span>Editar carpeta</span>
    </ion-button>

    <ng-container *ngIf="!item.unavailable">
      <app-print-settings-labels
        [printSettings]="item.product.printingGroup.printSettings"
        [files]="item.product.printingGroup.files"
        [size]="'small'"
      >
      </app-print-settings-labels>
    </ng-container>

    <div class="flex flex-col gap-2.5">
      <div class="item-price flex justify-start">
        <span>{{ item.product.printingGroup.files.length }} archivos (x{{ item.qty }} copias)</span>&nbsp;({{
          item.product.printingGroup.printSides
        }}
        páginas impresas por copia)
      </div>

      <ng-container *ngFor="let file of item.product.printingGroup.files">
        <div class="file-details flex w-full flex-col gap-2.5">
          <div class="file-alias flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
            <div class="flex flex-row items-center gap-1.5 lg:w-3/5">
              <img class="file-img" src="{{ file.thumbFile?.url }}" alt="" />
              <ion-text>{{ file.alias }}</ion-text>
            </div>

            <div class="flex flex-row items-center gap-2.5 lg:w-2/5 lg:justify-end">
              <div class="flex flex-row items-center gap-1.5 p-1" [ngClass]="{ 'opacity-40': file.coverLaminated }">
                <span class="front-back-paper"
                  >Folios en blanco <br />
                  <span class="font-medium">DELANTE:</span></span
                >
                <span class="text-sm">{{ file.blankSheetsBefore ?? 0 }}</span>
              </div>
              <div class="flex flex-row items-center gap-1.5 p-1">
                <span class="front-back-paper"
                  >Folios en blanco <br />
                  <span class="font-medium">DETRÁS:</span></span
                >
                <span class="text-sm">{{ file.blankSheetsAfter ?? 0 }}</span>
              </div>
            </div>
          </div>

          <div
            *ngIf="
              ![finishing.LAMINATED, finishing.LAMINATEDA4, finishing.LAMINATEDA3].includes(
                item.product.printingGroup.printSettings.finishing
              )
            "
            class="flex flex-row gap-2"
          >
            <img
              class="coverTypeIcon"
              [src]="
                fileService.getCoverTypeImage(file.coverType, {
                  docColor: file.docColor,
                  twoSided: item.product.printingGroup.printSettings.twoSided,
                  pagesPerSheet: item.product.printingGroup.printSettings.pagesPerSheet,
                })
              "
              alt=""
            />
            <div class="coverTypeSettings flex flex-col text-sm">
              <span class="leading-4">{{
                getCoverTypeSetting(file).title + (getCoverTypeSetting(file).value.twoSided ? '' : ', una cara')
              }}</span>
              <div class="annotations-row flex flex-row flex-wrap">
                <span
                  *ngIf="
                    ![finishing.LAMINATED, finishing.LAMINATEDA4, finishing.LAMINATEDA3].includes(
                      item.product.printingGroup.printSettings.finishing
                    )
                  "
                  class="blue"
                  >{{
                    file.coverLaminated
                      ? item.product.printingGroup.printSettings.paperWeight
                      : file.coverType.paperWeight
                  }}
                  gr</span
                >
                <span
                  *ngIf="item.product.printingGroup.printSettings.twoSided && getCoverTypeSetting(file).value.twoSided"
                  class="yellow"
                  >Sin despaginación</span
                >
                <span
                  *ngIf="item.product.printingGroup.printSettings.twoSided && !getCoverTypeSetting(file).value.twoSided"
                  class="pink"
                  >Con despaginación</span
                >
                <span
                  *ngIf="item.product.printingGroup.printSettings.twoSided && !getCoverTypeSetting(file).value.twoSided"
                  class="pink"
                  >Desconfigura tu documento</span
                >
              </div>
            </div>
          </div>

          <hr />

          <div class="flex flex-row items-center gap-2">
            <ion-icon
              class="text-lg"
              [src]="
                file.docColor
                  ? '../../../assets/icon/color-indicator.svg'
                  : '../../../assets/icon/black-white-indicator.svg'
              "
            ></ion-icon>
            <span class="text-sm"> {{ file.docColor ? 'Documento en color' : 'Documento en blanco y negro' }}</span>
          </div>

          <hr
            *ngIf="
              [finishing.LAMINATED, finishing.LAMINATEDA4, finishing.LAMINATEDA3].includes(
                item.product.printingGroup.printSettings.finishing
              )
            "
          />

          <div
            *ngIf="
              [finishing.LAMINATED, finishing.LAMINATEDA4, finishing.LAMINATEDA3].includes(
                item.product.printingGroup.printSettings.finishing
              )
            "
            class="flex flex-row items-center gap-2.5 text-sm"
          >
            <div class="flex flex-row items-center gap-1.5">
              <img
                [src]="
                  file.laminationType === 'gloss'
                    ? '../../../assets/images/finishings/brillo.png'
                    : '../../../assets/images/finishings/mate.png'
                "
                alt=""
              />
              <span> Plastificado {{ fileService.getLaminationTypeName(file.laminationType) }} </span>
            </div>

            <span class="text-gray-700">|</span>

            <span
              >{{
                fileService.getLaminationWeightName(file.laminationWeight, file.laminationType, file.coverLaminated)
              }}
              <span *ngIf="!file.coverLaminated">({{ file.laminationWeight }} micras)</span></span
            >
          </div>

          <hr *ngIf="item.product.printingGroup.binding" />

          <div *ngIf="item.product.printingGroup.binding" class="flex w-full flex-row gap-2.5">
            <div class="flex flex-1 flex-row items-center gap-2">
              <img
                class="ring-img"
                [src]="'assets/images/binding/rings/' + bindingOptionValue(file, 'ringColor', 'id') + '.png'"
                alt=""
              />
              <div class="flex flex-row gap-0.5">
                <span class="file-text" [ngClass]="{ noStock: false }"
                  >Anillas: {{ bindingOptionValue(file, 'ringColor', 'name') }}</span
                >
              </div>
            </div>

            <div class="flex flex-1 flex-row items-center gap-2">
              <app-cover-thumbnail
                class="cover-img"
                [id]="bindingOptionValue(file, 'hardCoverFront', 'id')"
                [color]="bindingOptionValue(file, 'hardCoverFront', 'color')"
                [width]="'15px'"
                [height]="'20px'"
              >
              </app-cover-thumbnail>
              <div class="flex flex-row gap-0.5">
                <ng-container *ngIf="!file.coverLaminated">
                  <span class="file-text" [ngClass]="{ noStock: withoutStock[file?.id]?.hardCoverFront }"
                    >Tapa delantera: {{ utils.getColorName(bindingOptionValue(file, 'hardCoverFront', 'name')) }}</span
                  >
                </ng-container>
                <ng-container *ngIf="file.coverLaminated">
                  <span class="file-text bold coverColorTag">
                    Portada {{ fileService.getLaminationTypeName(file.laminationType) }},
                    {{
                      fileService.getLaminationWeightName(
                        file.laminationWeight,
                        file.laminationType,
                        file.coverLaminated
                      )
                    }}
                    <span *ngIf="!file.coverLaminated">({{ file.laminationWeight }} micras)</span> </span
                  >&nbsp;
                </ng-container>
              </div>
            </div>

            <div class="flex flex-1 flex-row items-center gap-2">
              <app-cover-thumbnail
                class="cover-img"
                [id]="bindingOptionValue(file, 'hardCoverBack', 'id')"
                [color]="bindingOptionValue(file, 'hardCoverBack', 'color')"
                [width]="'15px'"
                [height]="'20px'"
              >
              </app-cover-thumbnail>
              <div class="flex flex-row gap-0.5">
                <span class="file-text" [ngClass]="{ noStock: withoutStock[file?.id]?.hardCoverBack }"
                  >Tapa trasera: {{ utils.getColorName(bindingOptionValue(file, 'hardCoverBack', 'name')) }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
